module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'workbench__row': true,
      'workbench__sm_row': _vm.isSM
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22269ac7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/views/workbenchCanvas/WorkbenchRow.vue
// module id = 1835
// module chunks = 0